import angular from 'angular';
import referrerConnect from './referrerConnect';
import './style.scss';

export default angular
  .module('components.referrerConnect', [])
  .component('referrerConnect', referrerConnect).name;
